import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = { style: {"width":"400px","height":"600px","margin-right":"20px"} }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "bi-tmpl-detail__right__cmpt__radioBox" }

import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import PcModuleCatalogue, {
  cataloguePaddingConfig
} from '../bi-pc-module/pc-module-catalogue';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-103',
  setup(__props) {

const TYPE_MAPPING = [1, 2, 3, 4, 5, 6].map(i => {
  return {
    value: 'pc-module-catalogue-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleCatalogue.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({});
const _catalogue = JSON.parse(
  '[{"title":"项目背景介绍","child":[{"title":"项目背景介绍","num":"01"}],"num":"01","index":0},{"title":"项目样本采集范围","child":[{"title":"项目样本采集范围","num":"02"}],"num":"02","index":1},{"title":"项目总览","child":[{"title":"项目总览","num":"05"}],"num":"05","index":2},{"title":"项目执行人数据统计","child":[{"title":"数据前处理","num":"06"},{"title":"参与任务执行的性别分析","num":"07"},{"title":"项目参与人完成的任务区间分布","num":"08"}],"num":"06","index":3},{"title":"项目相关分析模块","child":[{"title":"单因素分析","num":"10"},{"title":"多因素分析","num":"20"}],"num":"10","index":4}]'
);
//{"title":"交叉分析表与卡方分析","child":[{"title":"交叉分析表与卡方分析","num":"22"}],"num":"22","index":5},{"title":"单因素与多样本比较","child":[{"title":"单因素与多样本比较","num":"28"}],"num":"28","index":6},{"title":"相关性热图","child":[{"title":"相关性热图","num":"30"}],"num":"30","index":7},{"title":"示例分享","child":[{"title":"示例分享","num":"33"}],"num":"33","index":8},{"title":"项目执行流程","child":[{"title":"项目执行流程","num":"34"}],"num":"34","index":9},{"title":"项目执行进度","child":[{"title":"项目执行进度","num":"35"}],"num":"35","index":10}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 675,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING), (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "xrk-card",
                onClick: ($event: any) => (_unref(onChange)(item.value)),
                style: {"width":"1163px","height":"1665px","transform":"scale(0.36)","transform-origin":"0 0","border-radius":"10px !important","border-color":"#b7bcc6","overflow":"hidden"}
              }, [
                _createElementVNode("div", {
                  style: _normalizeStyle({
                padding: _unref(cataloguePaddingConfig)[
                  `pc-module-catalogue-${index + 1}`
                ]
                  .map(i => (typeof i === 'number' ? `${i}px` : i))
                  .join(' ')
              })
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)), {
                    taskSum: 300,
                    catalogue: _unref(_catalogue)
                  }, null, 8, ["catalogue"]))
                ], 4)
              ], 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(BaseRadio), {
                value: item.value,
                "model-value": _unref(curItem).value,
                onClick: ($event: any) => (_unref(onChange)(item.value))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(), 1)
                ]),
                _: 2
              }, 1032, ["value", "model-value", "onClick"])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})